import { NavLink, Outlet } from "react-router-dom";
import { LanguageSwitch } from "./LanguageSwitch";
import { useAuth } from "../lib/auth";
import { isDemoMode } from "../lib/demo-mode";
import { useI18n } from "../lib/i18n";

export function AppShell() {
  const { session, signOut } = useAuth();
  const { t } = useI18n();
  return (
    <div className="app-shell">
      <header className="topbar">
        <div className="brand">
          <img
            className="brand-logo"
            src="/bridge-ai-logo.png"
            alt={t("appTagline")}
          />
          <div>
            <strong>{t("appName")}</strong>
            <span>{t("appTagline")}</span>
          </div>
        </div>
        <div className="topbar-actions">
          <LanguageSwitch />
          {isDemoMode ? (
            <span className="avatar" aria-label={session?.displayName}>
              {session?.displayName.slice(0, 1).toUpperCase()}
            </span>
          ) : (
            <button
              className="avatar"
              type="button"
              onClick={signOut}
              title={t("signOut")}
            >
              {session?.displayName.slice(0, 1).toUpperCase()}
            </button>
          )}
        </div>
      </header>
      {isDemoMode && (
        <div className="demo-banner" role="status">
          <strong>{t("demoMode")}</strong>
          <span>{t("demoModeHint")}</span>
        </div>
      )}
      <main className="main-content">
        <Outlet />
      </main>
      <nav className="bottom-nav" aria-label="Primary navigation">
        <NavLink to="/" end>
          <span aria-hidden="true">⌂</span>
          {t("overview")}
        </NavLink>
        <NavLink to="/opportunities">
          <span aria-hidden="true">◇</span>
          {t("opportunities")}
        </NavLink>
        {session?.role === "bai_admin" && (
          <NavLink to="/admin">
            <span aria-hidden="true">⚙</span>
            {t("admin")}
          </NavLink>
        )}
      </nav>
    </div>
  );
}
